import { useTrackers } from '@ps/web-shared-analytics';
import { RawButton } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useDispatch } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { Dispatch } from '@swf/core/store';
import type { CasinoGame, CasinoTable } from '@swf/core/types/CasinoGame';

import styles from './CasinoStakeSelector.scss';

interface CasinoStakeSelectorParams {
  className?: string;
  game: CasinoGame;
  tables: CasinoTable[];
  raceId?: string;
  widgetId?: string;
}

const CasinoStakeSelector: React.FC = () => {
  const { className, game, tables, raceId, widgetId } =
    useSearchParams<CasinoStakeSelectorParams>();
  const { buttonPressed } = useTrackers();
  const { modal, casino } = useDispatch<Dispatch>();

  const handleClick = (table: CasinoTable) => {
    buttonPressed({ buttonName: 'Select Stake' });
    casino.launch({ table, raceId, widgetId });
    modal.close();
  };

  return (
    <>
      <Header>
        {game.name}
        <CloseButton />
      </Header>
      <Body className={classNames(className, styles.stakeSelector)}>
        {tables.map((table) => (
          <RawButton key={table.id} onClick={() => handleClick(table)}>
            <CurrencyAmount currency={table.currency} value={table.minBet} /> -{' '}
            <CurrencyAmount currency={table.currency} value={table.maxBet} />
          </RawButton>
        ))}
      </Body>
    </>
  );
};

export default CasinoStakeSelector;
